<div *ngIf="_userEventsAccessLevel > 0" class="wc-events-toolbar">
  <div class="container-fluid">
    <form class="form-horizontal" (submit)="$event.preventDefault(); handleSearchFormSubmit()">
      <span class="input-group">
        <span class="input-group-btn">
          <button pButton type="submit" class="btn btn-default" [disabled]="_searching.busy"
            [icon]="_searching.busy || _inlineSearching.busy ? null : 'pi pi-search'">
            <wl-busy *ngIf="_searching.busy || _inlineSearching.busy" [show]="true"></wl-busy>
          </button>
        </span>
        <input type="text" class="form-control" name="eventToolbarSearchKeyword" [(ngModel)]="keyword"
          (ngModelChange)="handleModelChange()" autocomplete="off"
          placeholder="{{ 'shared.container.toolbars.module.events.search-events-placeholder' | translate | ucfirst }}" />
        <span class="input-group-btn">
          <button pButton type="button" class="btn btn-default tall ml-5" icon="pi pi-times-circle"
            [hidden]="(!keyword || (keyword && !keyword.length)) && !_isEventSearchPage"
            [disabled]="_searching.busy || _inlineSearching.busy" (click)="handleResetClick()"></button>
          <button app-add-button *ngIf="_userEventsAccessLevel > 1" class="btn btn-default square-border"
            id="new-event-btn"
            [label]="'shared.container.toolbars.module.events.new-event-label' | translate | titlecase"
            (click)="handleNewEventClick()"></button>
          <button app-add-button *ngIf="_userEventsAccessLevel > 0" class="btn btn-default square-border"
            id="new-reg-btn" [title]="'shared.container.toolbars.module.events.new-registration-tooltip' | translate"
            [label]="'shared.container.toolbars.module.events.new-registration-label' | translate | titlecase"
            (click)="openSelectEventModal()"></button>
        </span>
      </span>
      <div *ngIf="_resultsOpen && !_inlineSearching.busy" class="wc-events-toolbar-search-result-outer-container">
        <div class="wc-events-toolbar-search-result-container">
          <div class="wc-events-toolbar-search-result">
            <div class="text-danger" *ngIf="!_inlineSearching.busy && !_inlineSearching.success">
              {{ _inlineSearching.message }}
            </div>

            <div *ngIf="!_inlineSearchResults.length && !_inlineSearching.busy && _inlineSearching.success">
              {{ 'shared.container.toolbars.module.events.no-results' | translate | ucfirst }}
            </div>

            <ul class="list-unstyled"
              *ngIf="_inlineSearchResults.length && !_inlineSearching.busy && _inlineSearching.success">
              <li *ngFor="let event of _inlineSearchResults">
                <a [routerLink]="['/event/', event.EventId]" (click)="closeResults()">{{ event.EventName }} ({{
                  event.StartDate | date: 'MM/dd/yyyy' }})</a>
              </li>
              <li class="wl-toolbar-click-for-more">
                {{ 'shared.container.toolbars.module.events.for-more-results' | translate | ucfirst }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="visible-xs-block visible-sm-block">
        <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-5 mt-5">
          <button app-add-button *ngIf="_userEventsAccessLevel > 1"
            [label]="'shared.container.toolbars.module.events.new-event-label' | translate | titlecase"
            (click)="handleNewEventClick()"></button>

          <button app-add-button *ngIf="_userEventsAccessLevel > 0"
            [title]="'shared.container.toolbars.module.events.new-registration-tooltip' | translate"
            [label]="'shared.container.toolbars.module.events.new-registration-label' | translate | titlecase"
            (click)="openSelectEventModal()"></button>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="_enableSelectEventModal">
    <p-dialog modal="true" #selectEventModal [(visible)]="showModal" [closable]="false" styleClass="atlas-dialog-m"
      [focusOnShow]="false" [contentStyle]="{ 'max-height': '70vh' }">
      <ng-template pTemplate="header">{{
        'shared.container.toolbars.module.events.select-event-title' | translate | titlecase
        }}</ng-template>
      <div class="container-fluid">
        <p>{{ 'shared.container.toolbars.module.events.new-registration-select-event-instruction' | translate }}</p>
        <wl-event-v4-select-event
          [selectButtonText]="'shared.container.toolbars.module.events.new-registration-select-event-button-label' | translate"
          [selectButtonGlyphIcon]="'plus'"
          (onEventSelect)="handleNewRegistrationEventSelect($event)"></wl-event-v4-select-event>
      </div>
      <ng-template pTemplate="footer">
        <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="closeSelectEventModal()">
        </cancel-button>
      </ng-template>
    </p-dialog>
  </div>

  <div>
    <wl-event-v4-registration-wizard #registrationWizardModalV4 (onRegistrationSaved)="handleRegistrationSaved($event)"
      (onRegistrationClose)="handleRegistrationClosed()"></wl-event-v4-registration-wizard>
  </div>

  <div *ngIf="_enableDeleteEventModal">
    <wl-event-v4-delete-event-modal #deleteEventModal [eventId]="_deleteEventId"
      (closeComplete)="handleDeleteModalClosed($event)"></wl-event-v4-delete-event-modal>
  </div>
</div>
